import styled from '@emotion/styled';

const PublishHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PublishMusicHeader = styled(PublishHeader)`
  margin-bottom: 24px;
`;

export const PublishEpisodeHeader = styled(PublishHeader)`
  margin-bottom: 36px;
`;

export const PublishDateContainer = styled.div`
  display: flex;
  align-items: flex-end;
  @media (max-width: 769px) {
    flex-direction: column;
    align-items: unset;
  }
`;

export const FieldToggleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  @media (max-width: 769px) {
    margin-top: 24px;
  }

  & > div {
    margin-right: 20px;
    margin-left: 32px;
    @media (max-width: 769px) {
      margin-left: 0px;
    }
  }
`;

export const SubscriptionImageLabel = styled.span`
  position: absolute;
  top: 216px;
  left: 8px;
  padding: 8px 16px;
  color: white;
  background-color: black;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
`;
